'use strict';

module.exports = {
    userProfile: function () {
        $.ajax({
            url: '/on/demandware.store/Sites-gamestop-us-Site/default/Account-Header',
            method: 'GET',
            success: function (data) {
                $('.js-header-user').html(data);
            }
        });
    }
};
